import React from "react";
import styled from "styled-components";

const PillContainer = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  min-width: 40px;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};
  border: 1px solid ${(props) => props.borderColor};
`;

const getTypeColors = (type) => {
  const colorMap = {
    success: {
      backgroundColor: "#d4edda",
      textColor: "#155724",
      borderColor: "#c3e6cb",
    },
    warning: {
      backgroundColor: "#fff3cd",
      textColor: "#856404",
      borderColor: "#ffeaa7",
    },
    error: {
      backgroundColor: "#f8d7da",
      textColor: "#721c24",
      borderColor: "#f5c6cb",
    },
    info: {
      backgroundColor: "#d1ecf1",
      textColor: "#0c5460",
      borderColor: "#bee5eb",
    },
  };

  return colorMap[type] || colorMap.info;
};

const StatusPill = ({ type = "info", label, testid }) => {
  if (!label) {
    return <span data-testid={testid || "status-pill-na"}>N/A</span>;
  }

  const colors = getTypeColors(type);

  return (
    <PillContainer
      backgroundColor={colors.backgroundColor}
      textColor={colors.textColor}
      borderColor={colors.borderColor}
      data-testid={testid || `status-pill-${type}`}
    >
      {label}
    </PillContainer>
  );
};

export default StatusPill;
